/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */

import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import styled from "styled-components";
import { datadogRum } from "@datadog/browser-rum";

import * as API from "../../../../api/billing";
import { ManualInvoiceModalBodyProps } from "../lib/types";
import {
  StyledButton,
  StyledButtonContainer,
  StyledInput,
  StyledLabel,
  StyledModalBody,
  StyledModalContents,
} from "../lib/styles";
import { redesignTheme } from "../../../theme/theme";

const StyledDataDiv = styled.div`
  font-family: ${redesignTheme.fontFamily};
  color: ${redesignTheme.color.gray900};
  font-size: ${redesignTheme.fontSize[100]};
  font-weight: ${redesignTheme.fontWeight.normal};
  line-height: 20px;
`;

const StyledDataDivLast = styled(StyledDataDiv)`
  margin-bottom: 32px;
`;

const ManualInvoiceModalBody = ({
  closeModal,
  companyId,
  fetchData,
  netTermDays,
  prepayAmount,
  prepayAmountDisplay,
  prepayThresholdDisplay,
  rewardBalanceDisplay,
  updateToastMessage,
}: ManualInvoiceModalBodyProps): React.ReactElement => {
  const defaultAmount = prepayAmount ? prepayAmount.toFixed(2) : "";
  const [amount, setAmount] = React.useState<string>(defaultAmount);

  const handleSendInvoiceClick = async (): Promise<void> => {
    try {
      const roundedAmount = parseFloat(amount).toFixed(2);
      const data = {
        amount_in_cents: parseFloat(roundedAmount) * 100,
        company_id: companyId,
      };
      await API.postManualInvoice(data);

      updateToastMessage({
        isOpen: true,
        message: i18n.translate("admin_pages.activity.manual_invoice.success"),
        type: "success",
      });
      fetchData();
      closeModal();
    } catch (error) {
      datadogRum.addError(error);
      updateToastMessage({
        isOpen: true,
        message: i18n.translate("admin_pages.activity.manual_invoice.error"),
        type: "error",
      });
    }
  };

  return (
    <StyledModalBody data-testid="manual-invoice-modal-body">
      <StyledModalContents>
        <StyledDataDiv data-testid="balance">
          {`${i18n.translate(
            "admin_pages.activity.manual_invoice.reward_balance"
          )}: ${rewardBalanceDisplay}`}
        </StyledDataDiv>
        <StyledDataDiv data-testid="prepay-amount">
          {`${i18n.translate(
            "admin_pages.activity.manual_invoice.prepay_block"
          )}: ${prepayAmountDisplay}`}
        </StyledDataDiv>
        <StyledDataDiv data-testid="prepay-threshold">
          {`${i18n.translate(
            "admin_pages.activity.manual_invoice.prepay_threshold"
          )}: ${prepayThresholdDisplay}`}
        </StyledDataDiv>
        <StyledDataDivLast data-testid="net-term-days">
          {`${i18n.translate(
            "admin_pages.activity.manual_invoice.net_term_days"
          )}: ${netTermDays}`}
        </StyledDataDivLast>
        <StyledLabel htmlFor="amount">
          {i18n.translate("admin_pages.activity.manual_invoice.invoice_amount")}
        </StyledLabel>
        <StyledInput
          data-testid="invoice-amount-input"
          id="amount"
          onChange={(event): void => {
            setAmount(event.target.value.replace(/-/g, ""));
          }}
          type="number"
          value={amount}
        />
      </StyledModalContents>
      <StyledButtonContainer>
        <StyledButton
          onClick={closeModal}
          size="small"
          testId="cancel-button"
          variant="secondary"
        >
          {i18n.translate("forms.cancel")}
        </StyledButton>
        <StyledButton
          disabled={!amount || amount === "0"}
          onClick={handleSendInvoiceClick}
          size="small"
          testId="send-invoice-button"
          variant="primary"
        >
          {i18n.translate("admin_pages.activity.manual_invoice.send_invoice")}
        </StyledButton>
      </StyledButtonContainer>
    </StyledModalBody>
  );
};

export default ManualInvoiceModalBody;
